import { Component } from "@angular/core";
import { UserService } from "../../../auth/user.service";
@Component({
  selector: "app-public-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class PublicFooterComponent {

  showMenu = true;
  loggedIn = false;
  selectedLanguage = localStorage.getItem('lang') || 'en';

  constructor(
    private readonly userService: UserService
  ) {
    this.loggedIn = this.userService.user !== undefined;
  }

  toggleMenu(): void {
    this.showMenu = !this.showMenu;
  }

  onChangeLanguage(lang: string): void {
    localStorage.setItem('lang', lang);
    window.location.reload();
  }

}
